import type * as Types from '../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateProfileMutationVariables = Types.Exact<{
  name: Types.Scalars['String']['input'];
}>;


export type CreateProfileMutationPage = { readonly __typename?: 'RootMutationType', readonly createProfile: { readonly __typename?: 'AccountsProfile', readonly id: string, readonly name?: string | null } };

export type UpdateProfileMutationVariables = Types.Exact<{
  name: Types.Scalars['String']['input'];
}>;


export type UpdateProfileMutationPage = { readonly __typename?: 'RootMutationType', readonly updateProfile: { readonly __typename?: 'AccountsProfile', readonly id: string, readonly name?: string | null } };

export type UpdatePasswordMutationVariables = Types.Exact<{
  currentPassword: Types.Scalars['String']['input'];
  newPassword: Types.Scalars['String']['input'];
}>;


export type UpdatePasswordMutationPage = { readonly __typename?: 'RootMutationType', readonly updatePassword: { readonly __typename?: 'AccountsUser', readonly id: string } };

export type EnableTwoFaMutationVariables = Types.Exact<{
  secret: Types.Scalars['String']['input'];
  code: Types.Scalars['String']['input'];
}>;


export type EnableTwoFaMutationPage = { readonly __typename?: 'RootMutationType', readonly enable2fa: { readonly __typename?: 'AccountsUser', readonly id: string } };

export type DisableTwoFaMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type DisableTwoFaMutationPage = { readonly __typename?: 'RootMutationType', readonly disable2fa: { readonly __typename?: 'AccountsUser', readonly id: string } };


export const CreateProfileDocument = gql`
    mutation CreateProfile($name: String!) {
  createProfile(name: $name) {
    id
    name
  }
}
    `;
export type CreateProfileMutationFn = Apollo.MutationFunction<CreateProfileMutationPage, CreateProfileMutationVariables>;

/**
 * __useCreateProfileMutation__
 *
 * To run a mutation, you first call `useCreateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProfileMutation, { data, loading, error }] = useCreateProfileMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateProfileMutation(baseOptions?: Apollo.MutationHookOptions<CreateProfileMutationPage, CreateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProfileMutationPage, CreateProfileMutationVariables>(CreateProfileDocument, options);
      }
export type CreateProfileMutationHookResult = ReturnType<typeof useCreateProfileMutation>;
export type CreateProfileMutationResult = Apollo.MutationResult<CreateProfileMutationPage>;
export type CreateProfileMutationOptions = Apollo.BaseMutationOptions<CreateProfileMutationPage, CreateProfileMutationVariables>;
export const UpdateProfileDocument = gql`
    mutation UpdateProfile($name: String!) {
  updateProfile(name: $name) {
    id
    name
  }
}
    `;
export type UpdateProfileMutationFn = Apollo.MutationFunction<UpdateProfileMutationPage, UpdateProfileMutationVariables>;

/**
 * __useUpdateProfileMutation__
 *
 * To run a mutation, you first call `useUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileMutation, { data, loading, error }] = useUpdateProfileMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfileMutationPage, UpdateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProfileMutationPage, UpdateProfileMutationVariables>(UpdateProfileDocument, options);
      }
export type UpdateProfileMutationHookResult = ReturnType<typeof useUpdateProfileMutation>;
export type UpdateProfileMutationResult = Apollo.MutationResult<UpdateProfileMutationPage>;
export type UpdateProfileMutationOptions = Apollo.BaseMutationOptions<UpdateProfileMutationPage, UpdateProfileMutationVariables>;
export const UpdatePasswordDocument = gql`
    mutation UpdatePassword($currentPassword: String!, $newPassword: String!) {
  updatePassword(currentPassword: $currentPassword, newPassword: $newPassword) {
    id
  }
}
    `;
export type UpdatePasswordMutationFn = Apollo.MutationFunction<UpdatePasswordMutationPage, UpdatePasswordMutationVariables>;

/**
 * __useUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePasswordMutation, { data, loading, error }] = useUpdatePasswordMutation({
 *   variables: {
 *      currentPassword: // value for 'currentPassword'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useUpdatePasswordMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePasswordMutationPage, UpdatePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePasswordMutationPage, UpdatePasswordMutationVariables>(UpdatePasswordDocument, options);
      }
export type UpdatePasswordMutationHookResult = ReturnType<typeof useUpdatePasswordMutation>;
export type UpdatePasswordMutationResult = Apollo.MutationResult<UpdatePasswordMutationPage>;
export type UpdatePasswordMutationOptions = Apollo.BaseMutationOptions<UpdatePasswordMutationPage, UpdatePasswordMutationVariables>;
export const EnableTwoFaDocument = gql`
    mutation EnableTwoFa($secret: String!, $code: String!) {
  enable2fa(secret: $secret, code: $code) {
    id
  }
}
    `;
export type EnableTwoFaMutationFn = Apollo.MutationFunction<EnableTwoFaMutationPage, EnableTwoFaMutationVariables>;

/**
 * __useEnableTwoFaMutation__
 *
 * To run a mutation, you first call `useEnableTwoFaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableTwoFaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableTwoFaMutation, { data, loading, error }] = useEnableTwoFaMutation({
 *   variables: {
 *      secret: // value for 'secret'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useEnableTwoFaMutation(baseOptions?: Apollo.MutationHookOptions<EnableTwoFaMutationPage, EnableTwoFaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableTwoFaMutationPage, EnableTwoFaMutationVariables>(EnableTwoFaDocument, options);
      }
export type EnableTwoFaMutationHookResult = ReturnType<typeof useEnableTwoFaMutation>;
export type EnableTwoFaMutationResult = Apollo.MutationResult<EnableTwoFaMutationPage>;
export type EnableTwoFaMutationOptions = Apollo.BaseMutationOptions<EnableTwoFaMutationPage, EnableTwoFaMutationVariables>;
export const DisableTwoFaDocument = gql`
    mutation DisableTwoFa {
  disable2fa {
    id
  }
}
    `;
export type DisableTwoFaMutationFn = Apollo.MutationFunction<DisableTwoFaMutationPage, DisableTwoFaMutationVariables>;

/**
 * __useDisableTwoFaMutation__
 *
 * To run a mutation, you first call `useDisableTwoFaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableTwoFaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableTwoFaMutation, { data, loading, error }] = useDisableTwoFaMutation({
 *   variables: {
 *   },
 * });
 */
export function useDisableTwoFaMutation(baseOptions?: Apollo.MutationHookOptions<DisableTwoFaMutationPage, DisableTwoFaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableTwoFaMutationPage, DisableTwoFaMutationVariables>(DisableTwoFaDocument, options);
      }
export type DisableTwoFaMutationHookResult = ReturnType<typeof useDisableTwoFaMutation>;
export type DisableTwoFaMutationResult = Apollo.MutationResult<DisableTwoFaMutationPage>;
export type DisableTwoFaMutationOptions = Apollo.BaseMutationOptions<DisableTwoFaMutationPage, DisableTwoFaMutationVariables>;